var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              attrs: {
                xs: "6",
                sm: "4",
                md: "4",
                lg: "2",
                id: "filter-controls",
              },
            },
            [
              _c("h3", { staticStyle: { display: "inline" } }, [
                _vm._v(_vm._s(this.$t("message.filters"))),
              ]),
              _c(
                "b-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { size: "md", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.clearAllFilters()
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(this.$t("message.clear_all")))]
              ),
              _c("br"),
              _c("br"),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "grouped-showInactive-form-group",
                    label: this.$t("message.projects"),
                  },
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "grouped-showInactive-form-checkbox",
                        value: "true",
                        "unchecked-value": "false",
                      },
                      model: {
                        value: _vm.showInactive,
                        callback: function ($$v) {
                          _vm.showInactive = $$v
                        },
                        expression: "showInactive",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(this.$t("message.show_inactive_projects")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "grouped-severity-form-group",
                    label: this.$t("message.severity"),
                  },
                },
                [
                  _c("b-form-checkbox-group", {
                    attrs: {
                      id: "grouped-severity-form-checkbox-group",
                      options: _vm.severityOptions,
                      stacked: "",
                    },
                    model: {
                      value: _vm.severitySelected,
                      callback: function ($$v) {
                        _vm.severitySelected = $$v
                      },
                      expression: "severitySelected",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "grouped-publish-date-form-group",
                    label: this.$t("message.published"),
                  },
                },
                [
                  _c("b-datepicker", {
                    attrs: {
                      id: "grouped-publish-date-datepicker-from",
                      max: _vm.publishDateTo,
                      placeholder: this.$t("message.from"),
                    },
                    model: {
                      value: _vm.publishDateFrom,
                      callback: function ($$v) {
                        _vm.publishDateFrom = $$v
                      },
                      expression: "publishDateFrom",
                    },
                  }),
                  _c("b-datepicker", {
                    attrs: {
                      id: "grouped-publish-date-datepicker-to",
                      min: _vm.publishDateFrom,
                      placeholder: this.$t("message.to"),
                    },
                    model: {
                      value: _vm.publishDateTo,
                      callback: function ($$v) {
                        _vm.publishDateTo = $$v
                      },
                      expression: "publishDateTo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "grouped-text-search-form-group",
                    label: this.$t("message.text_search"),
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "grouped-text-search-form-input",
                      debounce: "750",
                      placeholder: this.$t("message.search"),
                    },
                    model: {
                      value: _vm.textSearchInput,
                      callback: function ($$v) {
                        _vm.textSearchInput = $$v
                      },
                      expression: "textSearchInput",
                    },
                  }),
                  _vm._v("\n        Search in:\n        "),
                  _c("b-form-checkbox-group", {
                    attrs: {
                      id: "grouped-text-search-form-checkbox-group",
                      options: _vm.textSearchOptions,
                      stacked: "",
                    },
                    model: {
                      value: _vm.textSearchSelected,
                      callback: function ($$v) {
                        _vm.textSearchSelected = $$v
                      },
                      expression: "textSearchSelected",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "grouped-cvssv2-form-group",
                    label: this.$t("message.cvss_v2"),
                  },
                },
                [
                  _c(
                    "b-form-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "grouped-cvssv2-from-form-input",
                              type: "number",
                              min: "0",
                              max: _vm.cvssv2UpperLimit(),
                              step: "0.1",
                              debounce: "750",
                              state: _vm.cvssv2FromState(),
                              placeholder: this.$t("message.from"),
                            },
                            model: {
                              value: _vm.cvssv2From,
                              callback: function ($$v) {
                                _vm.cvssv2From = $$v
                              },
                              expression: "cvssv2From",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "grouped-cvssv2-to-form-input",
                              type: "number",
                              min: _vm.cvssv2LowerLimit(),
                              max: "10",
                              step: "0.1",
                              debounce: "750",
                              state: _vm.cvssv2ToState(),
                              placeholder: this.$t("message.to"),
                            },
                            model: {
                              value: _vm.cvssv2To,
                              callback: function ($$v) {
                                _vm.cvssv2To = $$v
                              },
                              expression: "cvssv2To",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "grouped-cvssv3-form-group",
                    label: this.$t("message.cvss_v3"),
                  },
                },
                [
                  _c(
                    "b-form-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "grouped-cvssv3-from-form-input",
                              type: "number",
                              min: "0",
                              max: _vm.cvssv3UpperLimit(),
                              step: "0.1",
                              debounce: "750",
                              state: _vm.cvssv3FromState(),
                              placeholder: this.$t("message.from"),
                            },
                            model: {
                              value: _vm.cvssv3From,
                              callback: function ($$v) {
                                _vm.cvssv3From = $$v
                              },
                              expression: "cvssv3From",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "grouped-cvssv3-to-form-input",
                              type: "number",
                              min: _vm.cvssv3LowerLimit(),
                              max: "10",
                              step: "0.1",
                              debounce: "750",
                              state: _vm.cvssv3ToState(),
                              placeholder: this.$t("message.to"),
                            },
                            model: {
                              value: _vm.cvssv3To,
                              callback: function ($$v) {
                                _vm.cvssv3To = $$v
                              },
                              expression: "cvssv3To",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "occurrences-form-group",
                    label: this.$t("message.occurrences_in_projects"),
                  },
                },
                [
                  _c(
                    "b-form-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "occurrences-from-form-input",
                              type: "number",
                              min: "0",
                              max: _vm.occurrencesUpperLimit(),
                              step: "1",
                              debounce: "750",
                              state: _vm.occurrencesFromState(),
                              placeholder: this.$t("message.from"),
                            },
                            model: {
                              value: _vm.occurrencesFrom,
                              callback: function ($$v) {
                                _vm.occurrencesFrom = $$v
                              },
                              expression: "occurrencesFrom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "occurrences-to-form-input",
                              type: "number",
                              min: _vm.occurrencesLowerLimit(),
                              step: "1",
                              debounce: "750",
                              state: _vm.occurrencesToState(),
                              placeholder: this.$t("message.to"),
                            },
                            model: {
                              value: _vm.occurrencesTo,
                              callback: function ($$v) {
                                _vm.occurrencesTo = $$v
                              },
                              expression: "occurrencesTo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { xs: "6", sm: "8", md: "8", lg: "10" } },
            [
              _c("bootstrap-table", {
                ref: "table",
                attrs: {
                  columns: _vm.columns,
                  data: _vm.data,
                  options: _vm.options,
                },
                on: { "on-load-success": _vm.onLoadSuccess },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }